// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/pages/TourPackage.jsx
import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from '../components/Header';
import TourTable from '../components/Tour/TourTable';
import TourForm from '../components/Tour/TourForm';
import '../css/Member.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { API_ENDPOINTS } from '../api/api';

const TourPackage = () => {
  const [tourData, setTourData] = useState([]);
  const [currentTour, setCurrentTour] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [formMode, setFormMode] = useState('add');
  const [searchQuery, setSearchQuery] = useState('');
  const [pageLength, setPageLength] = useState(10);
  
  const commonHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
  };

  const handleCancelEdit = () => {
    setIsFormVisible(false);
    setCurrentTour(null);
  };

  const handleRefresh = () => {
    fetchTourData();
  };

  const handlePageLengthChange = (e) => {
    setPageLength(parseInt(e.target.value, 10));
  };

  const fetchTourData = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.TOUR_PACKAGE_VIEW, {
        method: 'GET',
        headers: commonHeaders,
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setTourData(data); 
    } catch (error) {
      console.error('Fetch error:', error);
      setTourData([]);
    }
  };
  
  useEffect(() => {
    fetchTourData();
  }, []);

  const handleEditTour = (tourId) => {
    const idToFind = parseInt(tourId, 10);
    if (isNaN(idToFind)) {
        console.error("Invalid tourId provided:", tourId);
        return;
    }
    const tourToEdit = tourData.find((tour) => tour.travel_ID === idToFind);
    
    if (tourToEdit) {
      setCurrentTour(tourToEdit);
      setFormMode('edit');
      setIsFormVisible(true);
    } else {
      console.error("Tour not found for ID:", tourId);
    }
  };

  const handleAddTour = () => {
    setCurrentTour(null);
    setFormMode('add');
    setIsFormVisible(true);
  };

  // <<< ### จุดแก้ไข ###: รับพารามิเตอร์ `formModeFromChild` เพิ่ม
  const handleSaveTour = async (data, formModeFromChild) => {
    const userID = localStorage.getItem('user_ID');
    
    // ใช้ formModeFromChild ที่ส่งมาจาก TourForm
    if (formModeFromChild === 'edit' && !data.travel_ID) {
        console.error("Save failed: travel_ID is missing in edit mode.");
        return;
    }

    let dataToSend = { ...data, user_ID: parseInt(userID, 10) };

    const url = formModeFromChild === 'edit'
      ? API_ENDPOINTS.TOUR_PACKAGE_EDIT 
      : API_ENDPOINTS.TOUR_PACKAGE_CREATE;

    try {
      const response = await fetch(url, {
        method: formModeFromChild === 'edit' ? 'PUT' : 'POST', 
        headers: commonHeaders,
        body: JSON.stringify(dataToSend),
      });

      if (response.ok) {
        await fetchTourData();
        setIsFormVisible(false);
      } else {
        const errorData = await response.json();
        console.error('Failed to save tour:', errorData);
        throw new Error(errorData.message || 'Failed to save tour');
      }
    } catch (error) {
      console.error('Error saving tour:', error);
    }
  };

  const handleDelete = async (selectedTourIds) => {
    try {
      const response = await fetch(API_ENDPOINTS.TOUR_PACKAGE_DELETE, {
        method: 'DELETE',
        headers: commonHeaders,
        body: JSON.stringify({ ids: selectedTourIds }),
      });

      if (!response.ok) {
        throw new Error('Failed to delete tour packages');
      }
      fetchTourData();
    } catch (error) {
      console.error('Error deleting tour packages:', error);
    }
  };

  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboard-main">
        <Header
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          placeholderText="Search tour packages..."
          refreshData={handleRefresh}
          onBack={isFormVisible ? handleCancelEdit : undefined}
        />
        <div className="p-datatable-details">
          <div className="member-table-container">
            {!isFormVisible && (
              <div className="d-grid gap-2 d-md-flex justify-content-md-end mb-3">
                <div className="select-container me-md-2">
                  <select
                    id="pageLengthSelect"
                    className="form-select"
                    value={pageLength}
                    onChange={handlePageLengthChange}
                  >
                    <option value="10">10 Rows</option>
                    <option value="20">20 Rows</option>
                    <option value="50">50 Rows</option>
                    <option value="100">100 Rows</option>
                  </select>
                </div>
                <button onClick={handleAddTour} className="btn btn-dark btn-sm">
                  <FontAwesomeIcon icon={faPlus} /> Create New Tour Package
                </button>
              </div>
            )}

            {isFormVisible ? (
              <TourForm
                tourData={currentTour}
                mode={formMode}
                onCancel={handleCancelEdit}
                onSave={handleSaveTour}
              />
            ) : (
              <TourTable
                tourData={tourData}
                onEditTour={handleEditTour}
                onDelete={handleDelete}
                searchQuery={searchQuery}
                pageLength={pageLength}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourPackage;